/** @format */
import { AxiosRequestConfig } from 'axios';

import { client } from '@toucan/client/global/axios';
import { MarketCode } from '@toucan/client/global/market';

import { InventoryTags } from '@toucan/client/core/inventory/config/types';

export async function getProductTags(
    productIds: number[],
    marketCode: MarketCode
): Promise<InventoryTags> {
    const config: AxiosRequestConfig = {
        params: {
            product_ids: productIds.join(','),
        },
        headers: {
            'X-Market': marketCode,
        },
    };

    const response = await client.get('/inventory/tags/', config);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return response.data;
}
